<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    {{text.oneAppNotificationHistory}}
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">{{text.docs}}</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' !== errorMessage"> {{ errorMessage }} </alert-fail>
                      <b-form-group>
                        <b-input-group :prepend="text.filter">
                          <b-input v-model="searchText" :placeholder="text.pleaseEnterFilter"></b-input>
                        </b-input-group>
                      </b-form-group>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectedVariant="single"
                          selectable
                          :fields="fields"
                          :items="list">
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                        <b-pagination
                        class="pagination my-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        ></b-pagination>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>

        <!-- modal path -->

      <!-- confirm -->
      <alert-confirm
        :id="'confirmDelete'"
        @confirm="deleteNotificationHistory">
        confirm to delete this message ?
      </alert-confirm>

      <!-- Details -->
      <b-modal
        id="modal-details"
        ref="modal-details"
        :title="text.notificationDetails"
        size="xl"
        >
          <b-container fluid>
            <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
            <h5 class="margin-bottom-0">{{text.message}}</h5>
            <b-card>
              <li><b>{{text.topic}}</b> : {{details.title}}</li>
              <li><b>{{text.description}}</b>: {{details.message}}</li>
            </b-card>
            <h5 class="margin-bottom-0">{{text.sendTo}}</h5>
            <b-card>
                <li><b>{{text.platform}}</b> : {{details.platform}}</li>
                <li><b>{{text.type}}</b>: {{details.type}}</li>
                <li><b>{{text.destination}}</b>: {{details.value}}</li>
            </b-card>
          </b-container>
          <div slot="modal-footer" class="w-100">
          <b-button
            variant="danger"
            size="sm"
            class="float-right"
            :disabled="!isActive"
            v-b-modal.confirmDelete
          >
          <i class="fa fa-ban"></i>
            {{text.delete}}
          </b-button>
          <b-button
            variant="outline-dark"
            size="sm"
            class="float-right mr-2"
            @click="$refs['modal-details'].hide()"
          >
            {{text.close}}
          </b-button>
        </div>
      </b-modal>

      <!-- successfully  -->
      <b-modal
            ref="modal-success"
            title="Delete Successfully"
            size="lg"
            scrollable
            button-size="sm"
            centered
            header-class="p-2 border-bottom-0"
            footer-class="p-2 border-top-0"
            ok-only
            ok-variant="success"
            @hide="afterDeleteSuccess"
            >
            Delete notification history successfully,
        </b-modal>

    </div>
</template>

<script>
import AlertFail from '../../../components/alert/AlertFail';
import { dateToStringWithTimeFull } from '../../../assets/utils/time';
import AlertConfirm from '../../../components/alert/AlertConfirm';
import { textOneAppMessaging } from '@/assets/utils/language';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      isActive: true,
      currentPage: 1,
      numberPerPage: 20,
      fields: [],
      list: [],
      filter: {
        project: '',
        type: 'all'
      },
      delay: { time: 1000, interval: null },
      projectList: [],
      dataTable: [],
      details: {},
      searchText: '',
      text: {}
    };
  },
  methods: {
    viewDetails (e) {
      this.details = {};
      this.$refs['modal-details'].show();
      const details = this.dataTable.find(d => e.id === d.id);
      this.details.platform = details.to.platform;
      this.details.type = 'refId' === details.to.type ? 'email' : details.to.type;
      this.details.value = details.to.value.join(',');
      this.details.title = details.notification.title;
      this.details.message = details.notification.message;
      this.details.id = details.id;
    },
    getData () {
      this.isBusy = true;
      this.list = [];
      this.axios.get(process.env.VUE_APP_URL_MESSAGING_API + '/history/oneapp-notification?searchText=' + this.searchText)
        .then(response => {
          const data = response.data.data;
          if (data) {
            this.dataTable = data;
            this.list = data.map(d => {
              return {
                id: d.id,
                time: dateToStringWithTimeFull(new Date(d.createdAt.timestamp * 1000)),
                topic: d.notification.title,
                destination: d.to.value.map(value => {
                  if (!value) {
                    return '';
                  }
                  if (value.length > 8) {
                    try {
                      return value.substring(0, 8) + '...';
                    } catch (e) {
                      return (JSON.stringify(value)).substring(0, 8) + '...';
                    }
                  } else {
                    return value;
                  }
                }).join(',').substring(0, 16)
              };
            });
          }
        })
        .catch(error => {
          this.errorMessage = error.response ? error.response.data : error.message;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    deleteNotificationHistory () {
      this.isActive = false;
      this.isBusy = true;
      this.axios.delete(process.env.VUE_APP_URL_MESSAGING_API + '/history/' + this.details.id)
        .then(response => {
          this.$refs['modal-success'].show();
        })
        .catch(error => {
          this.errorMessage = error.response ? error.response.data : error.message;
        })
        .finally(() => {
          this.isBusy = false;
          this.isActive = true;
        });
    },
    afterDeleteSuccess () {
      this.$refs['modal-details'].hide();
      this.details = {};
      this.getData();
    },
    refreshFields () {
      this.fields = [
        { key: 'time', label: this.text.time },
        { key: 'topic', label: this.text.topic },
        { key: 'destination', label: this.text.destination }
      ];
    }
  },
  computed: {
    totalRows () {
      return this.list.length;
    }
  },
  components: {
    AlertFail,
    AlertConfirm
  },
  watch: {
    searchText () {
      if (this.delay.time < 1000) {
        this.delay.time = 1000;
      }
      if (null === this.delay.interval) {
        this.delay.interval = setInterval(() => {
          this.delay.time = this.delay.time - 200;
          if (0 === this.delay.time) {
            clearInterval(this.delay.interval);
            this.delay.interval = null;
            this.getData();
          }
        }, 100);
      }
    },
    $language: function () {
      this.text = textOneAppMessaging(this.$language);
      this.refreshFields();
    }
  },
  mounted () {
    this.text = textOneAppMessaging(this.$language);
    this.refreshFields();
    this.getData();
  }
};
</script>

<style scoped>
  .thumbnail{
        max-width: 100px;
    }
  .magin-minus-top-5{
      margin-top: -5px;
  }
  .margin-bottom-0{
      margin-bottom: 0px;
  }
</style>
<style>
    .pagination {
        margin-left: auto;
        margin-right: auto;
    }
    .users-filter .vs__search::placeholder,
    .users-filter .vs__dropdown-toggle,
    .users-filter .vs__dropdown-menu {
        color: #394066;
        font-variant: small-caps;
        border: 1px solid #e4e7ea;
    }
    .filter-status {
        margin-top: 1px;
    }
</style>
